<template>
  <section class="main-title">
    <div class="tit-des">{{ title }}</div>
    <span class="tit-slice"></span>
    <div class="tit-en-des" v-if="titleEn">{{ titleEn }}</div>
  </section>
</template>

<script>
export default {
  name: 'maintit',
  props: ['title', 'titleEn']
}
</script>

<style lang="scss" scoped>
.main-title {
  height: 66px;
  padding-top: 80px;
  text-align: center;
  border-bottom: 1px solid #eeeeee;
  .tit-slice {
    width: 24px;
    height: 4px;
    background: #50bbe5;
    border-radius: 100px;
    vertical-align: middle;
  }
  .tit-en-des {
    font-size: 14px;
    color: #cccccc;
    letter-spacing: 0;
    line-height: 17px;
  }
  .tit-des {
    font-size: 20px;
    color: #444444;
    letter-spacing: 0;
    font-weight: bold;
  }
  span {
    display: inline-block;
  }
}
</style>
